import { DsButton } from '@/modules/internal-v2/ds';
import type { SelectedItem } from './selection.types';

interface SelectionBarProps {
  selected: SelectedItem[];
  rejectEligibleCount: number;
  onApproveAll: () => void;
  onRejectAll: () => void;
  onClear: () => void;
  approveBusy: boolean;
  rejectBusy: boolean;
}

export function SelectionBar({
  selected,
  rejectEligibleCount,
  onApproveAll,
  onRejectAll,
  onClear,
  approveBusy,
  rejectBusy,
}: SelectionBarProps) {
  if (selected.length === 0) return null;

  const breakdown = countByResource(selected);

  return (
    <div className="sp-bulkbar">
      <div className="sp-bulkbar-inner">
        <span className="sp-bulkbar-count">{selected.length} ausgewählt</span>
        <span className="sp-bulkbar-breakdown">
          {[
            breakdown.productLine && `${breakdown.productLine} Linien`,
            breakdown.model && `${breakdown.model} Modelle`,
            breakdown.vocabulary && `${breakdown.vocabulary} Vokabular`,
          ]
            .filter(Boolean)
            .join(' · ')}
        </span>
        <div className="sp-bulkbar-spacer" />
        <DsButton variant="ghost" onClick={onClear}>
          Auswahl aufheben
        </DsButton>
        <DsButton
          variant="ghost"
          onClick={onRejectAll}
          disabled={rejectEligibleCount === 0 || rejectBusy}
          title={
            rejectEligibleCount < selected.length
              ? `${selected.length - rejectEligibleCount} können nicht abgelehnt werden (haben zugeordnete Artikel)`
              : undefined
          }
        >
          {rejectBusy
            ? 'Ablehne…'
            : rejectEligibleCount === selected.length
              ? `${selected.length} ablehnen`
              : `${rejectEligibleCount}/${selected.length} ablehnen`}
        </DsButton>
        <DsButton
          variant="primary"
          onClick={onApproveAll}
          disabled={approveBusy}
        >
          {approveBusy ? 'Gebe frei…' : `${selected.length} freigeben`}
        </DsButton>
      </div>
    </div>
  );
}

function countByResource(items: SelectedItem[]) {
  const out = { productLine: 0, model: 0, vocabulary: 0 };
  for (const it of items) out[it.resource]++;
  return out;
}
